import React from 'react';
import { connect } from 'react-redux';
import ChildDots from './ChildDots'
import BaseDot from './BaseDot'

const Dot = props => {
  let { id, number, client, server, x, y, root, px, py, page } = props
  if(!(number in client.status) || client.status[number]==='closed') {
    if(server.contents && server.contents[id]) {
      return(
        <div>
          <BaseDot id={id} number={number} x={x || client.x[number]}
            y={y || client.y[number]} px={px} py={py} root={root} page={page} />
        </div>
      )
    } else {
      return( null )
    }
  }
  return (
    <div>
      <ChildDots parent={number} id={id} root={root} page={page} />
      <BaseDot id={id} number={number} x={client.x[number]} y={client.y[number]}
        root={root} px={px} py={py} page={page} />
    </div>
  )
}


const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

export default connect(mapStateToProps)(Dot);



// WEBPACK FOOTER //
// ./src/components/dots/Dot.js